export default "__VITE_ASSET__Tzdd9k8R__"